
import React from "react";
import FeatureCard from "@/components/FeatureCard";
import { assetUrl } from "@/config/assets";

const MorningMagicSection = () => {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <FeatureCard
          title={<>Every Morning Brings <span className="text-elfPink-dark">New Elf Magic</span></>}
          description="Your family's Christmas elf creates personalized daily letters that celebrate achievements, make good on promises, and surprise children with delightful morning mischief with custom notes created just for your elves."
          imageSrc={assetUrl(
            "homepage-media/personalized-elf-letter-sample-magical-christmas-note-example.avif",
          )}
          imageAlt="Personalized elf letter sample with Christmas decorations"
          imageTitle="Magical Christmas elf letter example"
          reverse={false}
        />
      </div>
    </section>
  );
};

export default MorningMagicSection;
